import { useEffect, useEffectEvent, useState } from 'react';

const media = {
	mobile: '(width < 768px)',
	onlyTablet: '(768px <= width < 1200px)',
	desktop: '(width >= 1200px)',
};

export const useMedia = (key: keyof typeof media = 'mobile'): boolean => {
	const query = media[key];
	const [isNarrowScreen, setIsNarrowScreen] = useState(false);

	const setInitIsNarrowScreen = useEffectEvent((e: MediaQueryList) => setIsNarrowScreen(e.matches));

	useEffect(() => {
		const mediaWatcher = window.matchMedia(query);
		setInitIsNarrowScreen(mediaWatcher);

		function updateIsNarrowScreen(e: MediaQueryListEvent) {
			setIsNarrowScreen(e.matches);
		}

		mediaWatcher.addEventListener('change', updateIsNarrowScreen);
		return function cleanup() {
			mediaWatcher.removeEventListener('change', updateIsNarrowScreen);
		};
	}, [query]);
	return isNarrowScreen;
};
